export default "__VITE_ASSET__CkMciv_t__"